// assets/custom-cart-protect.js
(function () {
  'use strict';

  function hideSurchargeRemoveButtons() {
    // Cart rows - support multiple theme structures
    const rowSelectors = [
      '.cart-item',           // some themes
      '.cart__row',           // Dawn variations
      '.cart__items li',      // other themes
      '.cart-item-row',       // fallback
      '.cart-row'
    ];
    // find rows by selector union
    const rows = new Set();
    rowSelectors.forEach(sel => document.querySelectorAll(sel).forEach(r => rows.add(r)));

    // If no rows found, try generic selector for cart lines
    if (rows.size === 0) {
      document.querySelectorAll('[data-cart-item], [data-line-item], .cart__items li, .cart__row').forEach(r => rows.add(r));
    }

    rows.forEach(function (row) {
  try {
    // STRICT: only treat as add-on if explicit flag exists
    const isAddon =
      row.innerHTML.includes('_lv_addon') ||
      row.querySelector('[data-property-name="_lv_addon"]');

    if (!isAddon) return;

    // hide remove buttons
    const removeSelectors = [
      'a[href*="/cart/change"]',
      'a[href*="/cart/update"]',
      'a[href*="/cart/remove"]',
      '.cart__remove',
      '.cart-item__remove',
      '.cart-item__remove-button',
      '.cart__remove-item',
      '[data-action="remove"]',
      '.cart__remove-link',
      '.remove'
    ];

    const removeBtn = row.querySelector(removeSelectors.join(','));
    if (removeBtn) {
      removeBtn.style.display = 'none';
      removeBtn.setAttribute('aria-hidden', 'true');
      removeBtn.style.pointerEvents = 'none';
    }

    // disable quantity inputs
    const qtyInput = row.querySelector(
      'input[name="updates[]"], input.quantity__input, input.qty, input[name^="quantity"]'
    );
    if (qtyInput) {
      qtyInput.setAttribute('readonly', 'readonly');
      qtyInput.setAttribute('aria-disabled', 'true');
      qtyInput.style.pointerEvents = 'none';
    }

  } catch (err) {
    console.warn('cart-protect: row check error', err);
  }
});
  }
  

  // Run on initial load
  document.addEventListener('DOMContentLoaded', hideSurchargeRemoveButtons);
  // Run quickly in case content already present
  setTimeout(hideSurchargeRemoveButtons, 200);

  // Observe cart DOM changes (common containers)
  const cartContainer =
    document.querySelector('#main-cart-items') ||
    document.querySelector('.cart__items') ||
    document.querySelector('.cart-items') ||
    document.querySelector('#CartDrawer') ||
    document.querySelector('.cart-drawer');

  if (cartContainer) {
    try {
      const observer = new MutationObserver(function () {
        hideSurchargeRemoveButtons();
      });
      observer.observe(cartContainer, { childList: true, subtree: true });
    } catch (e) {
      // fallback to interval
      setInterval(hideSurchargeRemoveButtons, 1000);
    }
  } else {
    // fallback
    setInterval(hideSurchargeRemoveButtons, 1000);
  }
  
})();

